<template>
  <v-navigation-drawer
    v-model="drawerState"
    location="end"
    temporary
    :width="drawerWidth"
    color="sidebar"
  >
    <v-toolbar flat color="sidebar">
      <v-toolbar-title class="pl-1">{{ drawerTitle }}</v-toolbar-title>
      <v-btn icon @click="closeDrawer">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container style="margin-top: -16px;">
      <!-- Dynamically load component -->
      <component :is="component"/>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { useRightDrawerStore } from "@/store/rightDrawer";
import { computed, defineAsyncComponent } from "vue";

export default {
  name: "RightDrawer",
  setup() {
    const rightDrawerStore = useRightDrawerStore();

    const drawerTitle = computed(() => rightDrawerStore.drawerTitle);
    const drawerWidth = computed(() => rightDrawerStore.drawerWidth);
    const drawerState = computed({
      get: () => rightDrawerStore.isOpen,
      set: (value) => {
        if (!value) {
          rightDrawerStore.closeDrawer();
        }
      },
    });

    // Dynamically import the component based on the store value
    const component = computed(() => {
      const componentName = rightDrawerStore.component; // e.g., "CarListingsFilters"
      
      // Return a default or empty component if componentName is null or empty
      if (!componentName) {
        return defineAsyncComponent(() => import('../drawer/DefaultComponent.vue')); // Provide a default component path
      }

      return defineAsyncComponent(() =>
        import(`../drawer/${componentName}.vue`)
      );
    });

    return {
      drawerState,
      closeDrawer: rightDrawerStore.closeDrawer,
      drawerTitle,
      drawerWidth,
      component
    };
  },
};
</script>

<style scoped>
.bg-sidebar {
  border: 0px;
}
</style>
